module.exports = __webpack_public_path__ + "media/images/ruby-93185be4d0c1b4baf3780b42d278a134.ico";